var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{attrs:{"query":_vm.GET_PRODUCT,"variables":{ id: _vm.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.result.data;
var isLoading = ref.isLoading;
return [(isLoading)?_c('s-loader'):(data && data.product)?_c('div',[_c('ProductForm',{attrs:{"data":data.product,"mutation":_vm.UPDATE_PRODUCT,"parent-popup":_vm.parentPopup},on:{"mutation-done":_vm.productUpdated}})],1):_c('something-went-wrong')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }